export default __webpack_public_path__ + "static/media/AIRFRANCE_1.09e1ad5b.gif";